import { api, ApiError } from "./api.js";

/**
 * Open a stored CV in a new tab: GET …/resumes/{scanId}/file mints a 2-hour read link (audited).
 * The tab is opened synchronously on click and pointed at the link once it arrives — opening it
 * after the await would be swallowed by the browser's pop-up blocker. Resolves to an error message
 * for the caller to show, or null on success.
 */
export async function openResumeInTab(reqId: string, scanId: string): Promise<string | null> {
  const tab = window.open("about:blank", "_blank");
  try {
    const { url } = await api.get<{ url: string }>(`/requisitions/${reqId}/resumes/${scanId}/file`);
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      window.open(url, "_blank", "noopener");
    }
    return null;
  } catch (e) {
    tab?.close();
    return e instanceof ApiError ? e.message : "Couldn't open the CV — try again.";
  }
}
